// 订阅者管理
const subscriberManage = (resolve) => {
  import('components/russia/russia.subscriber').then((module) => {
    resolve(module)
  })
}
// 乘务员管理
const trainmanManage = (resolve) => {
  import('components/russia/russia.trainman').then((module) => {
    resolve(module)
  })
}
// 电子运单管理
const waybillManage = (resolve) => {
  import('components/russia/russia.waybill').then((module) => {
    resolve(module)
  })
}
// 线路信息
const lineInfo = (resolve) => {
  import('components/russia/russia.lineInfo').then((module) => {
    resolve(module)
  })
}
// 过境处信息
const borderInfo = (resolve) => {
  import('components/russia/russia.borderInfo').then((module) => {
    resolve(module)
  })
}

const russiaRouter = {
  russiaPath: [
    {
      path: '/russia/subscriber', // 订阅者管理
      component: subscriberManage
    },
    {
      path: '/russia/trainman', // 乘务员管理
      component: trainmanManage
    },
    {
      path: '/russia/waybill', // 电子运单管理
      component: waybillManage
    },
    {
      path: '/russia/lineInfo', // 线路信息
      component: lineInfo
    },
    {
      path: '/russia/borderInfo', // 过境处信息
      component: borderInfo
    }
  ]
}

export default russiaRouter



// WEBPACK FOOTER //
// ./src/router/russia.js